import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false,
      text: "Capex vs Opex",
    },
  },
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};

const labels = ["2025", "2026", "2027", "2028", "2029", "2030", "2031"];
//generate random data for 7 years with custom min and max
const generateRandomArray = (length, min, max) => {
  return Array.from(
    { length },
    () => Math.floor(Math.random() * (max - min + 1)) + min
  );
};

export const data = {
  labels,
  datasets: [
    {
      label: "CAPEX",
      data: generateRandomArray(labels.length, 20000, 40000),
      backgroundColor: "rgb(255, 99, 132)",
      stack: "stack0",
    },
    {
      label: "OPEX",
      data: generateRandomArray(labels.length, 5000, 25000),
      backgroundColor: "rgb(75, 192, 192)",
      stack: "stack1",
    },
  ],
};

function App({ changedValue }) {
  return (
    <div style={{ position: "relative", height: "434px", width: "100%" }}>
      <Bar options={options} data={data} />
    </div>
  );
}

export default App;
